import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  AccommodationType,
  AccommodationTypeValues,
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesAccommodationPublic,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionAccommodationPublicDto } from './dto.type';

export class QuestionAccommodationPublicMapper {
  static dtoToEntity(
    dto: QuestionAccommodationPublicDto,
  ): ImpactCo2Answer<ValuesAccommodationPublic> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'ACCOMMODATION_PUBLIC',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        accommodationType: validateValueInType<AccommodationType>(
          dto.accommodationType,
          AccommodationTypeValues,
        ),
        numberOfNights: dto.numberOfNights,
        guestCount: dto.guestCount,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesAccommodationPublic>,
    projectId: number,
  ): Omit<QuestionAccommodationPublicDto, 'id' | 'userId' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      accommodationType: answer.values.accommodationType,
      numberOfNights: answer.values.numberOfNights,
      guestCount: answer.values.guestCount,
      label: '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
